import React, { useState, useEffect } from "react";
import { useData } from "../util/dataProvider";
import arrow from "../images/arrow.svg";
import Select from "react-select";
import { kategorien, interesse } from "./kat";

export default function Filter({ setActive, active }) {
    const {
        fields,
        interests,
        updateFilter,
        fieldFilter,
        interestFilter,
        assetUrl,
    } = useData();

    const options = [];
    const interestOption = [];

    const [field, setField] = useState();
    const [interest, setinsterest] = useState();

    useEffect(() => {
        let menu = document.getElementById("hamburger");
        if (menu) {
            menu.style.opacity = "1";
        }
    }, []);

    kategorien &&
        kategorien.map((ober, idx) => {
            options.push({
                value: ober.oberKatLabel,
                label: ober.oberKatLabel,
                ober: true,
            });
            if (ober.unterKat.length > 1) {
                ober.unterKat.map((under) => {
                    options.push({ value: under.value, label: under.value });
                });
            }
        });

    interesse &&
        interesse.map((field, idx) => {
            interestOption.push({ value: field.value, label: field.value });
        });

    const fieldStyles = {
        option: (styles, { data }) => ({
            ...styles,
            color: data.ober ? "white" : "black",
            backgroundColor: data.ober ? " rgb(168, 39, 23)" : "white",
            fontSize: data.ober ? "22px" : "16px",
            paddingLeft: data.ober ? "12px" : "18px",
            ":hover": {
                backgroundColor: "#ccc",
                color: "black",
            },
        }),
        control: () => ({
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(168, 39, 23)",
            display: "flex",
            height: "100%",
            padding: "6px 3px",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "white",
            fontSize: "23px",
        }),
        multiValue: () => ({
            backgroundColor: "white",
            display: "flex",
            padding: "2px",
            borderRadius: "16px",
            margin: "2px",
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            borderRadius: "16px",
            ":hover": {
                backgroundColor: "#ccc",
                color: "black",
            },
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "white",
            fontSize: "23px",
        }),
    };

    return (
        <div className='filter-wrapper'>
            <Select
                options={[
                    { value: "all", label: "Alle" },
                    { value: "startup", label: "Start-Up" },
                    { value: "unternehmen", label: "Unternehmen" },
                    { value: "forschung", label: "Forschung" },
                    { value: "experten", label: "Expert*innen" },
                ]}
                closeMenuOnSelect={true}
                placeholder={"Alle"}
                styles={fieldStyles}
                onChange={(e) => {
                    console.log(e);
                    setActive(e.value);
                }}
                isMulti={false}
            />
            <Select
                options={options}
                closeMenuOnSelect={false}
                placeholder={"Alle Schwerpunkte"}
                styles={fieldStyles}
                value={field}
                onChange={(e) => {
                    setField(e);
                    let array = [];
                    for (let i = 0; i < e.length; i++) {
                        array.push(e[i].value);
                    }

                    updateFilter("fields", array);
                }}
                isMulti={true}
            />
            <Select
                options={interestOption}
                closeMenuOnSelect={false}
                placeholder={"Alle Interessen"}
                styles={fieldStyles}
                onChange={(e) => {
                    let array = [];
                    for (let i = 0; i < e.length; i++) {
                        array.push(e[i].value);
                    }

                    updateFilter("interests", array);
                }}
                isMulti={true}
            />
        </div>
    );
}
